import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

import { getAllRangesByType } from '../../../redux/selectors/productRange';
import fetchProductRange from '../../../redux/actions/productRange';
import { fetchHairDiagnosis } from '../../../redux/actions/hairDiagnosis';
import { getCurrentDiagnosisUser } from '../../../redux/selectors/hairDiagnosis';

import TreatmentRecommendations from '../../../components/TreatmentRecommendations/TreatmentRecommendations';
import Placeholder from '../../../components/Placeholder';
import ContentfulImage from '../../../components/ContentfulImage';

import {
  Category,
  CategoriesContainer,
  CategoriesWrapper,
  CategoryName,
  CurrentPage,
  FlexSpace,
  Hero,
  ImageContainer,
  Info,
  LastVisit,
  Name,
  Navigation,
  NextPage,
  Result,
  ResultInline,
  Section,
  SectionContent,
  SectionTitle,
  Separator,
  TitleWrapper,
  Wrapper,
} from './ProfilePage.style';

class ProfilePage extends React.Component {
  componentDidMount() {
    const { currentDiagnosisUser, locale, history, fetchProductRange, hairDiagnosis, fetchHairDiagnosis } = this.props;

    if (!currentDiagnosisUser) {
      history.push(`/${locale}/stylist/retrieve-profile`);
    } else {
      const { ranges } = currentDiagnosisUser.diagnosisResults[0];
      ranges.forEach(range => {
        if (!this.props.ranges[range[0]] || !this.props.ranges[range[0]][range[1]]) {
          fetchProductRange(range[1], locale, range[0]);
        }
      });
    }

    if (!hairDiagnosis.title) {
      fetchHairDiagnosis(locale);
    }
  }

  componentWillReceiveProps(nextProps) {
    const { currentDiagnosisUser, locale } = nextProps;
    if (
      !this.props.currentDiagnosisUser &&
      currentDiagnosisUser &&
      currentDiagnosisUser.diagnosisResults &&
      currentDiagnosisUser.diagnosisResults.length > 0
    ) {
      const { ranges } = currentDiagnosisUser.diagnosisResults[0];
      ranges.forEach(range => {
        if (!nextProps.ranges[range[0]] || !nextProps.ranges[range[0]][range[1]]) {
          fetchProductRange(range[1], locale, range[0]);
        }
      });
    }
  }

  render() {
    const { locale, copy, ranges, screenSize, currentDiagnosisUser, hairDiagnosis } = this.props;
    const diagnosisResults = currentDiagnosisUser ? currentDiagnosisUser.diagnosisResults : [{}];

    const lastUpdated = currentDiagnosisUser && new Date(currentDiagnosisUser.updatedAt);

    return (
      <Wrapper>
        {Object.keys(copy).length !== 0 && copy.constructor === Object ? (
          <Navigation>
            {Object.keys(copy).length !== 0 &&
              copy.constructor === Object &&
              screenSize >= 1 && (
                <span>
                  {copy.last_update}{' '}
                  {lastUpdated && `${lastUpdated.getDate()}/${lastUpdated.getMonth() + 1}/${lastUpdated.getFullYear()}`}
                </span>
              )}
            {Object.keys(copy).length !== 0 &&
              copy.constructor === Object && (
                <NextPage>
                  <Link to={`/${locale}/stylist/visits`} href={`/${locale}/stylist/visits`}>
                    {copy.salon_visit}
                  </Link>
                </NextPage>
              )}
            {Object.keys(copy).length !== 0 &&
              copy.constructor === Object && <CurrentPage>{copy.customer_profile}</CurrentPage>}
          </Navigation>
        ) : (
          <div>
            <Placeholder h="13px" w="100%" />
          </div>
        )}

        {Object.keys(copy).length !== 0 && copy.constructor === Object ? (
          <Hero>
            {screenSize < 1 && (
              <LastVisit>
                {copy.last_update}{' '}
                {lastUpdated && `${lastUpdated.getDate()}/${lastUpdated.getMonth() + 1}/${lastUpdated.getFullYear()}`}
              </LastVisit>
            )}
            <Name>{diagnosisResults[0].name}</Name>
            <Info>
              {diagnosisResults[0].age} | {diagnosisResults[0].gender} | {diagnosisResults[0].city},{' '}
              {diagnosisResults[0].country}
            </Info>
            <Category>
              <CategoryName>{copy.salon_frequency}</CategoryName>
              <Result>{diagnosisResults[0].salonVisitFrequency || <Placeholder h="13px" w="100%" />}</Result>
            </Category>
            <Category>
              <CategoryName>{copy.most_frequent_salon_activities}</CategoryName>
              {diagnosisResults[0].frequentSalonActivities ? (
                diagnosisResults[0].frequentSalonActivities.map(activity => (
                  <ResultInline key={activity}>{activity}</ResultInline>
                ))
              ) : (
                <Placeholder h="13px" w="100%" />
              )}
            </Category>
          </Hero>
        ) : (
          <Hero>
            <Placeholder h="450px" w="100%" />
          </Hero>
        )}

        <Separator />

        {Object.keys(copy).length !== 0 && copy.constructor === Object ? (
          <Section>
            <TitleWrapper>
              <FlexSpace />
              <SectionTitle>{copy.hair_profile}</SectionTitle>
            </TitleWrapper>
            <SectionContent>
              {screenSize >= 1 &&
                (hairDiagnosis.questions ? (
                  hairDiagnosis.questions[3] && (
                    <ImageContainer>
                      <ContentfulImage
                        src={hairDiagnosis.questions[3].image}
                        options={{
                          size: 320,
                          objectFit: 'cover',
                          w: '100%',
                        }}
                      />
                    </ImageContainer>
                  )
                ) : (
                  <div style={{ marginRight: '30px' }}>
                    <Placeholder h="170px" w="170px" />
                  </div>
                ))}
              <CategoriesWrapper>
                <CategoriesContainer>
                  <Category>
                    <CategoryName>{copy.hair_length}</CategoryName>
                    <Result>{diagnosisResults[0].hairLength || <Placeholder h="13px" w="100%" />}</Result>
                  </Category>
                  <Category>
                    <CategoryName>{copy.hair_thickness}</CategoryName>
                    <Result>{diagnosisResults[0].hairThickness || <Placeholder h="13px" w="100%" />}</Result>
                  </Category>
                  <Category>
                    <CategoryName>{copy.hair_texture}</CategoryName>
                    <Result>{diagnosisResults[0].hairTexture || <Placeholder h="13px" w="100%" />}</Result>
                  </Category>
                </CategoriesContainer>
                <CategoriesContainer>
                  <Category>
                    <CategoryName>{copy.state_of_hair}</CategoryName>
                    {diagnosisResults[0].hairState ? (
                      diagnosisResults[0].hairState.map(hairState => (
                        <ResultInline key={hairState}>{hairState}</ResultInline>
                      ))
                    ) : (
                      <Placeholder h="13px" w="100%" />
                    )}
                  </Category>
                </CategoriesContainer>
              </CategoriesWrapper>
            </SectionContent>
          </Section>
        ) : (
          <div>
            <Placeholder h="350px" w="100%" />
          </div>
        )}

        <Separator />

        {Object.keys(copy).length !== 0 && copy.constructor === Object ? (
          <Section>
            <TitleWrapper>
              <FlexSpace />
              <SectionTitle>{copy.hair_routine}</SectionTitle>
            </TitleWrapper>
            <SectionContent>
              {screenSize >= 1 &&
                (hairDiagnosis.questions ? (
                  hairDiagnosis.questions[5] && (
                    <ImageContainer>
                      <ContentfulImage
                        src={hairDiagnosis.questions[5].image}
                        options={{
                          size: 320,
                          objectFit: 'cover',
                          w: '100%',
                        }}
                      />
                    </ImageContainer>
                  )
                ) : (
                  <div style={{ marginRight: '30px' }}>
                    <Placeholder h="170px" w="170px" />
                  </div>
                ))}
              <CategoriesWrapper>
                <CategoriesContainer>
                  <Category>
                    <CategoryName>{copy.wash}</CategoryName>
                    <Result>{diagnosisResults[0].hairWashFrequency || <Placeholder h="13px" w="100%" />}</Result>
                  </Category>
                  <Category>
                    <CategoryName>{copy.treatment}</CategoryName>
                    <Result>{diagnosisResults[0].hairTreatmentFrequency || <Placeholder h="13px" w="100%" />}</Result>
                  </Category>
                  <Category>
                    <CategoryName>{copy.heat_tool}</CategoryName>
                    {diagnosisResults[0].heatTools ? (
                      diagnosisResults[0].heatTools.map(heatTool => <Result key={heatTool}>{heatTool}</Result>)
                    ) : (
                      <Placeholder h="13px" w="100%" />
                    )}
                  </Category>
                </CategoriesContainer>
              </CategoriesWrapper>
            </SectionContent>
          </Section>
        ) : (
          <div>
            <Placeholder h="350px" w="100%" />
          </div>
        )}

        <Separator />

        {Object.keys(copy).length !== 0 && copy.constructor === Object ? (
          <Section style={{ marginBottom: '100px' }}>
            <TitleWrapper>
              <FlexSpace />
              <SectionTitle>{copy.concerns_goals}</SectionTitle>
            </TitleWrapper>
            <SectionContent>
              {screenSize >= 1 &&
                (hairDiagnosis.questions ? (
                  hairDiagnosis.questions[8] && (
                    <ImageContainer>
                      <ContentfulImage
                        src={hairDiagnosis.questions[8].image}
                        options={{
                          size: 320,
                          objectFit: 'cover',
                          w: '100%',
                        }}
                      />
                    </ImageContainer>
                  )
                ) : (
                  <div style={{ marginRight: '30px' }}>
                    <Placeholder h="170px" w="170px" />
                  </div>
                ))}
              <CategoriesWrapper>
                <CategoriesContainer>
                  <Category>
                    <CategoryName>{copy.hair_concern}</CategoryName>
                    <Result>{diagnosisResults[0].hairConcern || <Placeholder h="13px" w="100%" />}</Result>
                  </Category>
                  <Category>
                    <CategoryName>{copy.scalp_concern}</CategoryName>
                    <Result>{diagnosisResults[0].scalpConcern || <Placeholder h="13px" w="100%" />}</Result>
                  </Category>
                </CategoriesContainer>
                {diagnosisResults[0].desiredFinish && (
                  <CategoriesContainer>
                    <Category>
                      <CategoryName>{copy.desired_finish}</CategoryName>
                      <Result>{diagnosisResults[0].desiredFinish}</Result>
                    </Category>
                  </CategoriesContainer>
                )}
              </CategoriesWrapper>
            </SectionContent>
          </Section>
        ) : (
          <div>
            <Placeholder h="350px" w="100%" />
          </div>
        )}

        {Object.keys(copy).length !== 0 &&
          copy.constructor === Object && (
            <TreatmentRecommendations
              ranges={
                Object.keys(ranges).length === 0 && ranges.constructor === Object
                  ? []
                  : diagnosisResults[0].ranges &&
                    diagnosisResults[0].ranges.map(range => ranges[range[0]] && ranges[range[0]][range[1]])
              }
              salonImage={hairDiagnosis.summarySalonSolutionsImage}
              salonText={hairDiagnosis.summarySalonSolutionsText}
              copy={copy}
              locale={locale}
            />
          )}
      </Wrapper>
    );
  }
}

ProfilePage.defaultProps = {
  copy: {},
  ranges: {},
  currentDiagnosisUser: null,
};

ProfilePage.propTypes = {
  copy: PropTypes.shape({}),
  locale: PropTypes.string.isRequired,
  ranges: PropTypes.shape({}),
  fetchProductRange: PropTypes.func.isRequired,
  screenSize: PropTypes.number.isRequired,
  currentDiagnosisUser: PropTypes.shape({}),
  history: PropTypes.shape({
    push: PropTypes.func,
  }).isRequired,
  hairDiagnosis: PropTypes.shape({
    summarySalonSolutionsImage: PropTypes.shape({}),
    summarySalonSolutionsText: PropTypes.string,
  }).isRequired,
  fetchHairDiagnosis: PropTypes.func.isRequired,
};

const mapState = state => ({
  copy: state.siteOptions.siteCopyStylistToolProfilePage,
  locale: state.locale,
  ranges: getAllRangesByType(state),
  screenSize: state.screenSize,
  currentDiagnosisUser: getCurrentDiagnosisUser(state),
  hairDiagnosis: state.hairDiagnosis,
});

const mapDispatch = dispatch => ({
  fetchProductRange: (slug, locale, rangeType) => dispatch(fetchProductRange(slug, locale, rangeType)),
  fetchHairDiagnosis: locale => dispatch(fetchHairDiagnosis(locale)),
});

export default connect(mapState, mapDispatch)(ProfilePage);



// WEBPACK FOOTER //
// ./src/pages/StylistToolPages/ProfilePage/ProfilePage.js